import { appPathWithTenant } from './tenantHost';

export const LEGAL_PAGE_SLUGS = ['terms', 'privacy', 'accessibility', 'cancel'] as const;

export type LegalPageSlug = (typeof LEGAL_PAGE_SLUGS)[number];

export function isLegalPageSlug(value: string | undefined): value is LegalPageSlug {
  return Boolean(value && (LEGAL_PAGE_SLUGS as readonly string[]).includes(value));
}

export function legalPath(slug: LegalPageSlug, tenantSlug?: string | null): string {
  return appPathWithTenant(`/legal/${slug}`, tenantSlug);
}

/** Set before leaving a legal page via Close — website shell scrolls to the footer. */
export const LEGAL_RETURN_FOOTER_KEY = 'catalogofworks-legal-return-footer';

export type LegalReturnLocationState = {
  legalReturnFooter?: boolean;
};

/** Path the visitor was on when they opened a legal page from the footer. */
export const LEGAL_FROM_PATH_KEY = 'catalogofworks-legal-from-path';
